<button
    (click)="buttonClick.emit()"
    [class]="labelClasses()"
    [attr.aria-label]="ariaLabel()">
    <ng-content></ng-content>
</button>
